import React from 'react';
import {
  BulkActionsContext,
  type BulkActionsContextType,
} from '../../providers/bulk-actions-provider/bulk-actions-provider.component';
import { createBulkActionReportingStore } from '../../bulk-action-reporting/bulk-action-reporting.store';

const fallbackStore = createBulkActionReportingStore();

const fallbackValue: BulkActionsContextType = {
  actions: [],
  reportingSession: undefined,
  clearReportingSession: () => {},
  cancelActiveOperation: () => {},
  retryActiveOperation: undefined,
  activeReportingOperation: null,
  setActiveReportingOperation: () => {},
  operationStartedAt: null,
  setOperationStartedAt: () => {},
  resetBulkActionReportingState: () => {},
  isBulkPublishOpen: false,
  setIsBulkPublishOpen: () => {},
  bulkPublishSelectedEntities: [],
  bulkActionReportingStore: fallbackStore,
};

export const useBulkActionsReporting = (): BulkActionsContextType => {
  const context = React.useContext(BulkActionsContext);
  if (context === null) {
    console.error(
      'useBulkActionsReporting must be used within a BulkActionsProvider',
    );
    return fallbackValue;
  }
  return context;
};
